// extracted by css-extract-rspack-plugin
export default {"reviewText":"reviewText-u4fA23","reviewRoot":"reviewRoot-oi8ySO","reviewRootScoped":"reviewRootScoped-jyjkxf","reviewScroll":"reviewScroll-o_tZZm","reviewRow":"reviewRow-FQY95d"};